import React from 'react';
import AppShell from '../../components/app-shell/app-shell';
import PublicShell from '../../components/app-shell/public-shell';
import PublicMarkdown from '../../components/markdown/public-markdown';
import CalligraphySuppliesGuide from '../../components/landing-pages/calligraphy-supplies-guide';
import markdown from './calligraphy-supplies-guide.md';

export default function() {
  return (
    <AppShell
      seoTitle="Calligraphy Supplies Guide"
      description="Purchase lettering supplies directly from Calligraphy.org."
    >
      <PublicShell>
        <CalligraphySuppliesGuide />
        <PublicMarkdown markdown={markdown} />
      </PublicShell>
    </AppShell>
  );
}
